import React from 'react';
import styled from 'styled-components';
import * as Bento from '@prezi/bento';
import * as Atoms from '../../../atoms';
import { createDataLookup } from '../../../const';
import { useConfig } from '../../../../utils/config';
import { DisabledComponentWithTooltipWrapper } from '../';
import { localI18n } from '../../../../i18n';
const uxCopy = {
  title: localI18n._("Public"),
  desc: localI18n._("Published on Prezi gallery and discoverable by search engines.")
};
const GridColumn = styled(Atoms.Dumb.ColumnMinAutoMin).withConfig({
  displayName: "TogglePublic__GridColumn",
  componentId: "mz5fxi-0"
})(["column-gap:8px;padding-inline-start:4px;"]);
const ToggleEnabled = ({
  checked,
  handleOnChange
}) => React.createElement(Bento.Switch, {
  checked: checked,
  name: "document-public-toggle",
  id: "document-public-toggle",
  onChange: ev => {
    handleOnChange(ev.currentTarget.checked);
  },
  onEnterKeyPress: () => {
    handleOnChange(!checked);
  },
  "data-lookup": createDataLookup('set-public-toggle')
});
const ToggleDisabled = ({
  checked,
  controlContext
}) => {
  const {
    onUpgrade
  } = useConfig();
  return React.createElement(DisabledComponentWithTooltipWrapper, {
    uxCopyTooltip: controlContext.uxCopy,
    onActionTooltip: controlContext.paywall && (() => onUpgrade('pitch_privacy_private')),
    paywall: controlContext.paywall
  }, React.createElement(Bento.Switch, {
    disabled: controlContext.disabled,
    checked: checked,
    name: "document-public-toggle",
    id: "document-public-toggle",
    "data-lookup": createDataLookup('set-public-toggle')
  }));
};
const TogglePublic = ({
  checked,
  controlContext,
  handleOnChange
}) => React.createElement(GridColumn, null, React.createElement(Atoms.Icons.Public, null), React.createElement(Atoms.Dumb.FlexColumn, null, React.createElement(Bento.Body2, null, uxCopy.title), React.createElement(Bento.Caption, null, uxCopy.desc)), controlContext.disabled ? React.createElement(ToggleDisabled, {
  checked: checked,
  controlContext: controlContext
}) : React.createElement(ToggleEnabled, {
  checked: checked,
  handleOnChange: handleOnChange
}));
export default TogglePublic;